
/* ================= DTO ================= */

import { ResponseModel } from "../models/ResponseModel";
import { AjaxService } from "../shared/services/AjaxService";

export interface ExerciseDto {
    exerciseId?: string | null;
    userId?: string | null;
    date: string; // yyyy-MM-dd
    exerciseTypeId: string;
    otherType?: string | null;
    duration: string; // HH:mm:ss
}

export interface ExerciseHistoryFilterDto {
    userId?: string | null;
    fromDate: string;
    toDate: string;
}

export interface ExerciseHistoryItem {
    date: string; // dd-MM-yyyy
    data: {
        exerciseId: string;
        exerciseTypeId: string;
        exerciseTypeName: string;
        otherType?: string;
        duration: string;
    };
}

export interface EnumerationItem {
    enumerationId: string;
    code: string;
    value: string;
    sequence: number;
    parameter?: string;
}

/* ================= SERVICE ================= */

export const ExerciseService = {

    // 🔹 Get Enumeration
    async getExerciseTypes(code: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(
            `/Enumeration/getEnumeration?code=${encodeURIComponent(code)}`
        );
    },

    // 🔹 Create
    async create(payload: ExerciseDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Exercise/create", payload);
    },

    // 🔹 Update
    async update(payload: ExerciseDto): Promise<ResponseModel> {
        return AjaxService.put<ResponseModel>("/Exercise/update", payload);
    },

    // 🔹 Get by Id
    async getExercise(exerciseId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(
            `/Exercise/getExercise?exerciseId=${encodeURIComponent(exerciseId)}`
        );
    },

    // 🔹 Delete
    async delete(exerciseId: string): Promise<ResponseModel> {
        return AjaxService.delete<ResponseModel>(
            `/Exercise/delete?exerciseId=${encodeURIComponent(exerciseId)}`
        );
    },

    // 🔹 History
    async getExerciseHistory(payload: ExerciseHistoryFilterDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Exercise/getExerciseHistory", payload);
    },
};
